// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"PC-module__modalHeader___iP7F6","header":"PC-module__header___3WWUd","children":"PC-module__children___1eaj3","child":"PC-module__child___f2ape"};